import React from "react";
import FontAwesome from "react-fontawesome";
import Api from "../../Api";
import Utils from "../../Api/Utils";
import AdminTitle from "../../components/AdminTitle/index";
import {Link} from "react-router";
import Select from "react-select";
import Button from "../../components/Button";

export default class AdminRetailerView extends React.Component {
  constructor(props) {
    super(props);

    this.reloadOutstandingPayments = this.reloadOutstandingPayments.bind(this);
    this.getOrders = this.getOrders.bind(this);
    this.getDisplayOrder = this.getDisplayOrder.bind(this);
    this.getDisplayShipmentsFor = this.getDisplayShipmentsFor.bind(this);
    this.getDisplayShipment = this.getDisplayShipment.bind(this);
    this.getDisplayOrderItemsFor = this.getDisplayOrderItemsFor.bind(this);
    this.getDisplayOrderItem = this.getDisplayOrderItem.bind(this);
    this.onChargeClicked = this.onChargeClicked.bind(this);
    this.onSelectAllCredit = this.onSelectAllCredit.bind(this);
    this.onSelectAllNet90 = this.onSelectAllNet90.bind(this);
    this.onClearSelection = this.onClearSelection.bind(this);

    this.findProductOption = this.findProductOption.bind(this);

    this.state = {
      response: null,
      error: null,
      selectedAmountCents: 0,
      selectedOrderTokens: {},
      selectedShipmentTokens: {},
      selectedOrderItemTokens: {}
    };

    this.orderItems = {};
  }

  componentDidMount() {
    this.reloadOutstandingPayments();
  }

  reloadOutstandingPayments() {
    this.setState({
      response: null,
      error: null,
      selectedAmountCents: 0,
      selectedOrderTokens: {},
      selectedShipmentTokens: {},
      selectedOrderItemTokens: {}
    });

    Api.getOutstandingIncomingPayments(this.props.params.retailerToken).then(
      (response) => {
        // Map received order items.
        this.orderItems = {};
        response.order_items.forEach(orderItem => {
          this.orderItems[orderItem.token] = orderItem;
        });

        // Reset state.
        this.setState({
          response: response,
          error: null,
          selectedAmountCents: 0,
          selectedOrderTokens: {},
          selectedShipmentTokens: {},
          selectedOrderItemTokens: {}
        });
      },
      (error) => {
        if (error.httpStatusCode >= 500) {
          this.setState({error: 'Server error processing request'});
        } else {
          this.setState({error: 'Error: ' + error.message});
        }
      }
    );
  }

  getOrders(user) {
    return Object.keys(this.state.response.orders).map((orderToken) => {
      return this.getDisplayOrder(user, this.state.response.orders[orderToken]);
    });
  }

  getDisplayOrder(user, order) {
    let shipments = this.getDisplayShipmentsFor(order);
    let orderItems = this.getDisplayOrderItemsFor(order);

    let selected = this.state.selectedOrderTokens[order.token] === true;
    let orderLink = "/admin/orders/" + order.token;

    return (
      <div key={order.token}>
        <hr/>
        <input
          type="checkbox"
          value={order.token}
          checked={selected}
          onChange={this.onOrderSelectedChanged.bind(this, order.token, !selected)}
        />
        <Link to={orderLink} target="_blank">Order {order.token}</Link> created at {Utils.millisToYMD(order.created_at)}

        {shipments.displayShipments}
        {orderItems.displayOrderItems}

        <PaymentSelector
          user={user}
          orderToken={order.token}
          shipmentTokens={shipments.shipmentTokens}
          orderItemTokens={orderItems.orderItemTokens}
          totalCents={shipments.totalCents + orderItems.totalCents}
          onChargeClicked={this.onChargeClicked}
        />
      </div>
    );
  };

  onOrderSelectedChanged(orderToken, selected) {
    let selectedOrderTokens = this.state.selectedOrderTokens;
    let selectedShipmentTokens = this.state.selectedShipmentTokens;
    let selectedOrderItemTokens = this.state.selectedOrderItemTokens;
    let selectedAmountCents = this.state.selectedAmountCents;

    selectedOrderTokens[orderToken] = selected;

    let shipments = this.state.response.shipments;
    for (let i = 0; i < shipments.length; i++) {
      let shipment = shipments[i];
      if (selected && !this.canPayForShipment(shipment)) continue;
      if (shipment.order_token === orderToken) {
        let currentSelection = selectedShipmentTokens[shipment.token] === true;
        if (currentSelection === selected) continue;

        let shipmentCostCents = shipment.cost_cents || 0;
        selectedAmountCents += selected ? shipmentCostCents : -shipmentCostCents;
        if (selected) {
          selectedShipmentTokens[shipment.token] = selected;
        } else {
          delete selectedShipmentTokens[shipment.token];
        }
      }
    }

    let orderItems = this.state.response.order_items;
    for (let i = 0; i < orderItems.length; i++) {
      let orderItem = orderItems[i];
      if (orderItem.order_token === orderToken) {
        let currentSelection = selectedOrderItemTokens[orderItem.token] === true;
        if (currentSelection === selected) continue;

        selectedAmountCents += selected ? orderItem.total_cents : -orderItem.total_cents;
        if (selected) {
          selectedOrderItemTokens[orderItem.token] = selected;
        } else {
          delete selectedOrderItemTokens[orderItem.token];
        }
      }
    }

    this.setState({
      selectedOrderTokens,
      selectedShipmentTokens,
      selectedOrderItemTokens,
      selectedAmountCents
    });
  }

  getDisplayShipmentsFor(order) {
    let shipments = this.state.response.shipments;
    let shipmentTokens = [];
    let totalCents = 0;

    let displayShipments = [];
    for (let i = 0; i < shipments.length; i++) {
      let shipment = shipments[i];
      if (shipment.order_token !== order.token) continue;
      shipmentTokens.push(shipment.token);
      if (!shipment.free) {
        totalCents += shipment.cost_cents || 0;
      }

      displayShipments.push(this.getDisplayShipment(shipment));
    }
    return {displayShipments, shipmentTokens, totalCents};
  }

  getDisplayShipment(shipment) {
    let displayCost;
    let costCents = 0;
    let selected = this.state.selectedShipmentTokens[shipment.token] === true;
    if (shipment.free) {
      displayCost = "Free (PROMO CODE)";
    } else {
      displayCost = shipment.cost_cents === undefined
        ? "Missing!"
        : (shipment.cost_cents === 0 ? "Free" : "$" + Utils.formatCents(shipment.cost_cents));
      costCents = shipment.cost_cents || 0;
    }

    let brandName = '';
    for (let i = 0; i < shipment.order_item_tokens.length; i++) {
      let orderItemToken = shipment.order_item_tokens[i];
      if (this.orderItems[orderItemToken]) {
        let orderItem = this.orderItems[orderItemToken];
        let product = this.state.response.products[orderItem.product_token];
        brandName = this.state.response.brands[product.brand_token].name;
        break;
      }
    }

    return (
      <div key={shipment.token}>
        <input
          type="checkbox"
          value={shipment.token}
          checked={selected}
          onChange={this.onShipmentSelectedChanged.bind(this, shipment, costCents, !selected)}
        />
        Shipment {shipment.token} - {brandName} - delivered
        at {shipment.delivered_at ? Utils.millisToYMD(shipment.delivered_at) : "N/A"} for {displayCost}
      </div>
    );
  }

  canPayForShipment(shipment) {
    // We can pay for shipments once they were shipped (have a shipping date) and either have cost or are free.
    return shipment.shipped_at !== undefined && (shipment.free === true || shipment.cost_cents !== undefined);
  }

  onShipmentSelectedChanged(shipment, shipmentCostCents, selected) {
    let selectedAmountCents = this.state.selectedAmountCents;
    let selectedShipmentTokens = this.state.selectedShipmentTokens;

    if (selected && !this.canPayForShipment(shipment)) {
      alert('Cannot select shipment ' + shipment.token + ' missing cost or shipping date');
      return;
    }

    if (selected) {
      selectedShipmentTokens[shipment.token] = selected;
    } else {
      delete selectedShipmentTokens[shipment.token];
    }

    selectedAmountCents += selected ? shipmentCostCents : -shipmentCostCents;
    this.setState({selectedAmountCents, selectedShipmentTokens});
  }

  getDisplayOrderItemsFor(order) {
    let orderItems = this.state.response.order_items;
    let orderItemTokens = [];
    let totalCents = 0;

    let displayOrderItems = [];
    for (let i = 0; i < orderItems.length; i++) {
      let orderItem = orderItems[i];
      if (orderItem.order_token !== order.token) continue;

      orderItemTokens.push(orderItem.token);
      totalCents += orderItem.total_cents;

      displayOrderItems.push(this.getDisplayOrderItem(orderItem));
    }
    return {displayOrderItems, orderItemTokens, totalCents};
  }

  getDisplayOrderItem(orderItem) {
    let selected = this.state.selectedOrderItemTokens[orderItem.token] === true;
    let displayCost = Utils.formatCents(orderItem.total_cents);
    let product = this.state.response.products[orderItem.product_token];
    let brand = this.state.response.brands[product.brand_token];
    let productOption = this.findProductOption(product, orderItem.product_option_token);

    return (
      <div key={orderItem.token}>
        <input
          type="checkbox"
          value={orderItem.token}
          checked={selected}
          onChange={this.onOrderItemSelectedChanged.bind(this, orderItem, !selected)}
        />
        {brand.name} - {product.name} - {productOption.name} - {orderItem.state} - {orderItem.quantity} X
        ${Utils.formatCents(orderItem.price_cents)} = ${displayCost}
      </div>
    );
  }

  onOrderItemSelectedChanged(orderItem, selected) {
    let selectedAmountCents = this.state.selectedAmountCents;
    let selectedOrderItemTokens = this.state.selectedOrderItemTokens;

    if (selected) {
      selectedOrderItemTokens[orderItem.token] = selected;
    } else {
      delete selectedOrderItemTokens[orderItem.token];
    }
    selectedAmountCents += selected ? orderItem.total_cents : -orderItem.total_cents;

    this.setState({selectedAmountCents, selectedOrderItemTokens});
  }

  findProductOption(product, optionToken) {
    for (let i = 0; i < product.options.length; i++) {
      let option = product.options[i];
      if (option.token === optionToken) return option;
    }
    return null;
  }

  onChargeClicked(orderToken, instrumentToken) {
    let selectedShipmentTokens = [];
    let selectedOrderItemTokens = [];
    let totalCost = 0;

    this.state.response.shipments.forEach(shipment => {
      if (!orderToken || shipment.order_token === orderToken) {
        if (this.state.selectedShipmentTokens[shipment.token] === true) {
          selectedShipmentTokens.push(shipment.token);
          if (!shipment.free) {
            totalCost += shipment.cost_cents || 0;
          }
        }
      }
    });

    this.state.response.order_items.forEach(orderItem => {
      if (!orderToken || orderItem.order_token === orderToken) {
        if (this.state.selectedOrderItemTokens[orderItem.token] === true) {
          selectedOrderItemTokens.push(orderItem.token);
          totalCost += orderItem.total_cents;
        }
      }
    });

    if (selectedShipmentTokens.length === 0 && selectedOrderItemTokens.length === 0) {
      return; // nothing to do!
    }

    if (confirm(`The customer will be charged $${Utils.formatCents(totalCost)}! Continue?`) !== true) {
      return;
    }

    let request = {
      retailer_token: this.props.params.retailerToken,
      instrument_token: instrumentToken,
      shipment_tokens: selectedShipmentTokens,
      order_item_tokens: selectedOrderItemTokens,
      total_amount_cents: totalCost
    };

    return Api.chargeRetailer(request).then(
      (payment) => {
        let failureReason = payment.failure_reason;
        alert('Payment submitted. State = ' + payment.state + (failureReason ? '. Reason: ' + failureReason : ''));
        if (payment.state !== 'FAILED') this.reloadOutstandingPayments();
      },
      error => {
        if (error.httpStatusCode >= 500) {
          alert('Server error processing request: ' + error.message);
        } else {
          alert('Error: ' + error.message);
        }
      });
  }

  onSelectAllCredit() {
    let selectedOrderTokens = {};
    let selectedShipmentTokens = {};
    let selectedOrderItemTokens = {};
    let selectedAmountCents = 0;

    this.state.response.shipments.forEach(shipment => {
      if (this.canPayForShipment(shipment)) {
        selectedShipmentTokens[shipment.token] = true;
        if (!shipment.free) {
          selectedAmountCents += shipment.cost_cents || 0;
        }
      }
    });

    this.state.response.order_items.forEach(orderItem => {
      if (orderItem.state === 'SHIPPED' || orderItem.state === 'DELIVERED') {
        selectedOrderItemTokens[orderItem.token] = true;
        selectedAmountCents += orderItem.total_cents;
      }
    });

    this.setState({selectedAmountCents, selectedOrderTokens, selectedShipmentTokens, selectedOrderItemTokens});
  }

  onSelectAllNet90() {
    let selectedOrderTokens = {};
    let selectedShipmentTokens = {};
    let selectedOrderItemTokens = {};
    let selectedAmountCents = 0;

    this.state.response.shipments.forEach(shipment => {
      if (this.canPayForShipment(shipment)) {
        selectedShipmentTokens[shipment.token] = true;
        if (!shipment.free) {
          selectedAmountCents += shipment.cost_cents || 0;
        }
      }
    });

    const now = new Date();

    this.state.response.order_items.forEach(orderItem => {
      if (orderItem.state === 'SHIPPED' || orderItem.state === 'DELIVERED') {
        let itemShippedAt = new Date(orderItem.shipped_at);

        let daysSinceShipped = Utils.dateDiffInDays(now, itemShippedAt);
        if (daysSinceShipped >= 90) {
          selectedOrderItemTokens[orderItem.token] = true;
          selectedAmountCents += orderItem.total_cents;
        }
      }
    });

    this.setState({selectedAmountCents, selectedOrderTokens, selectedShipmentTokens, selectedOrderItemTokens});
  }

  onClearSelection() {
    this.setState({
      selectedAmountCents: 0,
      selectedOrderTokens: {},
      selectedShipmentTokens: {},
      selectedOrderItemTokens: {}
    });
  }

  render() {
    if (this.state.error) return <div>{this.state.error}</div>;

    if (!this.state.response) return <FontAwesome name="refresh" spin/>;

    let retailer = this.state.response.retailer;
    let shipmentCount = Object.keys(this.state.selectedShipmentTokens).length;
    let totalShipmentCount = this.state.response.shipments.length;
    let selectedShipments = `Shipments: ${shipmentCount}/${totalShipmentCount}`;


    let totalOrderItemCount = this.state.response.order_items.length;
    let orderItemCount = Object.keys(this.state.selectedOrderItemTokens).length;
    let selectedOrderItems = `Order Items: ${orderItemCount}/${totalOrderItemCount}`;

    let selectedTotal = `Total: $${Utils.formatCents(this.state.selectedAmountCents)}`;

    let paymentDiv = (
      <div>
        <PaymentSelector
          user={this.state.response.user}
          orderToken={null}
          shipmentTokens={Object.keys(this.state.selectedShipmentTokens)}
          orderItemTokens={Object.keys(this.state.selectedOrderItemTokens)}
          totalCents={this.state.selectedAmountCents}
          onChargeClicked={this.onChargeClicked}
        />
      </div>
    );

    return (
      <div>
        <AdminTitle title={retailer.name + ' / Outstanding payments'}/>
        <div>
          <br/>
          {selectedShipments} {selectedOrderItems} {selectedTotal}
          <Button onClick={this.onClearSelection}>Clear</Button>
          <Button onClick={this.onSelectAllCredit}>All Credit</Button>
          <Button onClick={this.onSelectAllNet90}>All Net 90</Button>
        </div>
        {paymentDiv}
        {this.getOrders(this.state.response.user)}
      </div>
    );
  }
}

class PaymentSelector extends React.Component {
  constructor(props) {
    super(props);

    this.onInstrumentChange = this.onInstrumentChange.bind(this);
    this.onChargeInstrument = this.onChargeInstrument.bind(this);

    this.state = {selectedInstrumentToken: null};

    let user = props.user;

    this.instruments = user.instruments.map(instrument => {
      let card = instrument.card;
      let bankAccount = instrument.bank_account;

      if (instrument.card) {
        let brand = 'Card';
        switch (card.brand) {
          case 'VISA':
            brand = 'Visa';
            break;
          case 'AMERICAN_EXPRESS':
            brand = 'Amex';
            break;
          case 'MASTERCARD':
            brand = 'Mastercard';
            break;
          case 'DISCOVER':
            brand = 'Discover';
            break;
          case 'JCB':
            brand = 'Jbc';
            break;
          case 'DINERS_CLUB':
            brand = 'Diners';
            break;
          default:
            brand = card.brand;
            break;
        }
        return {label: `${brand} ${card.last_four}`, value: instrument.token}
      } else {
        return {label: `Bank account ${bankAccount.account_number}`, value: instrument.token}
      }
    });

    let selectedInstrumentToken = null;
    if (this.instruments.length > 0) {
      selectedInstrumentToken = user.instruments[0].token;
    }
    this.state = {selectedInstrumentToken: selectedInstrumentToken};
  }

  onInstrumentChange(selected) {
    this.setState({selectedInstrumentToken: selected.value});
  }

  onChargeInstrument() {
    this.props.onChargeClicked(this.props.orderToken, this.state.selectedInstrumentToken);
  }

  render() {
    if (this.instruments.length === 0) return <span>No instrument linked!</span>;

    let selectedInstrumentToken = this.state.selectedInstrumentToken;

    return (
      <div>
        <Select name="instrument"
                options={this.instruments}
                onChange={this.onInstrumentChange}
                clearable={false}
                searchable={false}
                value={selectedInstrumentToken}/>
        <Button onClick={this.onChargeInstrument}>Charge instrument</Button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/RetailerView.js
 **/